import React, { Component } from "react";
import CountryList from "country-list";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Table, Tbody, Td, Th, Thead, Tr } from 'react-super-responsive-table';

const initialState = {
  categories: [],
  game: {
    categories: [{ name: null, slug: null }],
    provider: {
      slug: null,
    },
    aggregator: {},
    blocked_countries: [],
  },
  reportLoading: false,
  gameReport: {
    data: {
      provider: {},
    },
  },
  newCategoryName: "",
  newCategoryNameTranslation: {},
};

class GameProviderGamePage extends Component {
  constructor(props) {
    super(props);
    this.countries = CountryList();

    this.state = initialState;
  }

  componentDidMount() {
    this.fetchGame();
  }

  async fetchGame() {
    await window.api
      .get(`/admin/games/${this.props.match.params.slug}`)
      .then((game) => this.setState({ game }));
  }

  async changeRTP() {
    const rtp = window.prompt(`Enter RTP value for this game`);
    if (rtp) {
      await window.api
        .post(`/admin/games/${this.props.match.params.slug}/change_rtp`, {
          rtp,
        })
        .then(() => {
          toast.success(`Success`);
          this.fetchGame();
        })
        .catch((err) => toast.error(err));
    }
  }

  async toggleFreeSpins() {
    const { free_spins_allowed } = this.state.game;
    const alert = window.confirm(
      `Are you sure you want to ${free_spins_allowed ? "disable" : "enable"} free spins for this game?`
    );

    if (!alert) return;

    await window.api
      .post(
        `/admin/games/${this.props.match.params.slug}/toggle_free_spins_allowed`,
        {
          free_spins_allowed: !free_spins_allowed,
        }
      )
      .then(() => {
        toast.success(`Success`);
        this.fetchGame();
      })
      .catch((err) => toast.error(err));
  }

  async changeSlug() {
    const new_slug = window.prompt(
      `Enter a new globally unique slug for this game`
    );
    if (new_slug) {
      await window.api
        .post(`/admin/games/${this.props.match.params.slug}/change_slug`, {
          new_slug,
        })
        .then(() => {
          toast.success(`Success`);
          this.props.history.push(`/casino/games/${new_slug}`);
          this.fetchGame();
        })
        .catch((err) => toast.error(err));
    }
  }

  async changeGameName() {
    const new_game_name = window.prompt(
      `Enter a new globally unique name for this game`
    );
    if (new_game_name) {
      await window.api
        .post(`/admin/games/${this.props.match.params.slug}/change_game_name`, {
          new_game_name,
        })
        .then(() => {
          toast.success(`Success`);
          this.fetchGame();
        })
        .catch((err) => toast.error(err));
    }
  }

  async moveToNewProvider() {
    const destination_provider_slug = window.prompt(
      `Enter the slug of the provider you would like to move this game to`
    );

    if (destination_provider_slug) {
      await window.api
        .post(
          `/admin/games/${this.props.match.params.slug}/move_to_new_provider`,
          {
            destination_provider_slug,
          }
        )
        .then(() => {
          toast.success(`Success`);
          this.fetchGame();
        })
        .catch((err) => toast.error(err));
    }
  }

  async changeImageUrl(file, gameId, newTempImage) {
    toast.info(`Uploading image...`);
    const image_url = await window.api.upload(
      file,
      "games",
      newTempImage ? `${gameId}-new` : gameId
    );

    await window.api
      .post(`/admin/games/${this.props.match.params.slug}/change_image`, {
        image_url,
        is_new_image: newTempImage,
      })
      .then(() => {
        toast.success(`Image changed`);
        this.fetchGame();
      })
      .catch((err) => toast.error(err));
  }

  async toggleDesktopMobile(platform = "desktop") {
    let enabled = false;
    if (platform === "desktop") {
      enabled = this.state.game.desktop_allowed;
    } else {
      enabled = this.state.game.mobile_allowed;
    }

    const alert = window.confirm(
      `Are you sure you want to ${enabled ? "disable" : "enable"} ${platform}_allowed for this game?`
    );

    if (!alert) return;

    await window.api
      .put(
        `/admin/games/${this.props.match.params.slug}/desktop-mobile`,
        {
          platform,
          value: !enabled
        }
      )
      .then(() => {
        toast.success(`Success`);
        this.fetchGame();
      })
      .catch((err) => toast.error(err));

    if (platform === "desktop") {
      this.state.game.desktop_allowed = !enabled;
    } else {
      this.state.game.mobile_allowed = !enabled;
    }
  }

  render() {
    const {
      id,
      image_url,
      name,
      slug,
      provider,
      aggregator,
      blocked_countries,
      hit_rate,
      paylines,
      return_to_player,
      free_spins_allowed,
      desktop_allowed,
      mobile_allowed,
      volatility_rating,
      released_at,
      remote_id,
      image_url_new,
      demo_allowed,
    } = this.state.game;
    return (
      <div className="row game-page">
        <div className="col-md-12">
          <div
            className="data"
            style={{
              lineHeight: "2",
              display: "flex",
              alignItems: "flex-start",
            }}
          >
            <div>
              <img
                src={image_url}
                style={{ width: "250px", height: "250px", borderRadius: "5px" }}
              />
              <br />
              <h2>NEW IMAGE URL {image_url_new ? "👇" : "NOT SET"}</h2>
              {image_url_new && (
                <img
                  src={image_url_new}
                  style={{
                    width: "250px",
                    height: "250px",
                    borderRadius: "5px",
                  }}
                />
              )}
            </div>

            <div style={{ marginLeft: "40px" }}>
              <Table>
                <Thead>
                  <Tr>
                    <Th>Field</Th>
                    <Th>Value</Th>
                    <Th>Action</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  <Tr>
                    <Td>Name</Td>
                    <Td>{name}</Td>
                    <Td>
                      <button onClick={() => this.changeGameName()} className="small">
                        Change
                      </button></Td>
                  </Tr>
                  <Tr>
                    <Td>Slug</Td>
                    <Td>{slug}</Td>
                    <Td>
                      <button onClick={() => this.changeSlug()} className="small">
                        Change
                      </button>
                    </Td>
                  </Tr>
                  <Tr>
                    <Td>Remote ID</Td>
                    <Td>{remote_id}</Td>
                    <Td></Td>
                  </Tr>
                  <Tr>
                    <Td>Aggregator</Td>
                    <Td>{remote_id ? remote_id.split(":")[0] : ""}</Td>
                    <Td></Td>
                  </Tr>
                  <Tr>
                    <Td>Provider</Td>
                    <Td>
                      <Link to={`/casino/game-providers/${provider.slug}`}>
                        {provider.name}
                      </Link>
                    </Td>
                    <Td>
                      <button
                        onClick={() => this.moveToNewProvider()}
                        className="small"
                      >
                        Move
                      </button></Td>
                  </Tr>
                  <Tr>
                    <Td>Aggregator</Td>
                    <Td>{aggregator.name}</Td>
                    <Td></Td>
                  </Tr>
                  <Tr>
                    <Td>Blocked countries</Td>
                    <Td>{blocked_countries.toString()}</Td>
                    <Td></Td>
                  </Tr>
                  <Tr>
                    <Td>Hit rate</Td>
                    <Td>{hit_rate}</Td>
                    <Td></Td>
                  </Tr>
                  <Tr>
                    <Td>Paylines</Td>
                    <Td>{paylines}</Td>
                    <Td></Td>
                  </Tr>
                  <Tr>
                    <Td>RTP</Td>
                    <Td>{return_to_player}%</Td>
                    <Td><button onClick={() => this.changeRTP()} className="small">
                      Change
                    </button></Td>
                  </Tr>
                  <Tr>
                    <Td>Volatility rating</Td>
                    <Td>{volatility_rating}</Td>
                    <Td></Td>
                  </Tr>
                  <Tr>
                    <Td>Free spins allowed</Td>
                    <Td>{free_spins_allowed ? "enabled" : "disabled"}</Td>
                    <Td><button onClick={() => this.toggleFreeSpins()} className="small">
                      {free_spins_allowed ? "disable" : "enable"}
                    </button></Td>
                  </Tr>
                  <Tr>
                    <Td>Desktop allowed</Td>
                    <Td>{desktop_allowed ? "enabled" : "disabled"}</Td>
                    <Td><button onClick={() => this.toggleDesktopMobile()} className="small">
                      {desktop_allowed ? "disable" : "enable"}
                    </button></Td>
                  </Tr>
                  <Tr>
                    <Td>Mobile allowed</Td>
                    <Td>{mobile_allowed ? "enabled" : "disabled"}</Td>
                    <Td><button onClick={() => this.toggleDesktopMobile('mobile')} className="small">
                      {mobile_allowed ? "disable" : "enable"}
                    </button></Td>
                  </Tr>
                  <Tr>
                    <Td>Demo allowed</Td>
                    <Td>{demo_allowed ? "yes" : "no"}</Td>
                    <Td></Td>
                  </Tr>
                  <Tr>
                    <Td>Release date</Td>
                    <Td>{released_at}</Td>
                    <Td></Td>
                  </Tr>
                  <Tr>
                    <Td>Id</Td>
                    <Td>{id}</Td>
                    <Td></Td>
                  </Tr>
                  <Tr>
                    <Td>Upload Image</Td>
                    <Td><input
                      type="file"
                      onChange={async (e) => {
                        this.changeImageUrl(e.target.files[0], id);
                      }}
                    /></Td>
                    <Td></Td>
                  </Tr>
                  <Tr>
                    <Td>Upload Image NEW WITH NEW FORMAT</Td>
                    <Td><input
                      type="file"
                      onChange={async (e) => {
                        this.changeImageUrl(e.target.files[0], id, true);
                      }}
                    /></Td>
                    <Td></Td>
                  </Tr>
                </Tbody>
              </Table>
            </div>
          </div>
          <hr />
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  languages: state.app.languages,
});

export default connect(mapStateToProps)(GameProviderGamePage);
